query AnalyticsRevenueByDate(
  $filter: AnalyticsSalesFilterInput!
  $calendarInterval: CalendarInterval
) {
  analyticsSales(filter: $filter) {
    currency
    revenueByDate(calendarInterval: $calendarInterval) {
      calendarInterval
      items {
        label
        displayCurrency
        data {
          x
          y
        }
      }
    }
  }
}
